"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByAnalytics = exports.sortByNumericalField = exports.sortByField = exports.alphanumericSort = void 0;

var _SortDirections = require("../constants/SortDirections");

var reA = /[^a-zA-Z]/g;
var reN = /[^0-9]/g;

var alphanumericSort = function alphanumericSort(a, b) {
  var aA = a.replace(reA, '');
  var bA = b.replace(reA, '');

  if (aA === bA) {
    var aN = parseInt(a.replace(reN, ''), 10);
    var bN = parseInt(b.replace(reN, ''), 10);

    if (aN === bN) {
      return 0;
    } else if (aN > bN) {
      return 1;
    }

    return -1;
  }

  return aA > bA ? 1 : -1;
};

exports.alphanumericSort = alphanumericSort;

var sortByField = function sortByField(field) {
  var UITableSortDir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ascending';
  var sortDir = _SortDirections.UITableSortDirections[UITableSortDir];
  return function (a, b) {
    return alphanumericSort(a.get(field).toLowerCase(), b.get(field).toLowerCase()) * sortDir;
  };
};

exports.sortByField = sortByField;

var sortByNumericalField = function sortByNumericalField(field) {
  var UITableSortDir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ascending';
  var sortDir = _SortDirections.UITableSortDirections[UITableSortDir];
  return function (a, b) {
    if (isNaN(a.get(field)) && !isNaN(b.get(field))) {
      return -1 * sortDir;
    } else if (!isNaN(a.get(field)) && isNaN(b.get(field))) {
      return Number(sortDir);
    } else if (isNaN(a.get(field)) && isNaN(b.get(field))) {
      return 0;
    } else if (a.get(field) < b.get(field)) {
      return -1 * sortDir;
    } else if (a.get(field) > b.get(field)) {
      return Number(sortDir);
    }

    return 0;
  };
};

exports.sortByNumericalField = sortByNumericalField;

var sortByAnalytics = function sortByAnalytics(analytics, property) {
  var UITableSortDir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ascending';
  var sortDir = _SortDirections.UITableSortDirections[UITableSortDir];
  return function (a, b) {
    if (!analytics.has(a.id.toString())) {
      return analytics.has(b.id.toString()) ? -1 * sortDir : 0;
    } else if (!analytics.has(b.id.toString())) {
      return analytics.has(a.id.toString()) ? Number(sortDir) : 0;
    }

    var aTotals = analytics.get(a.id.toString()).totals;
    var bTotals = analytics.get(b.id.toString()).totals;

    if (!aTotals && !bTotals) {
      return 0;
    } else if (aTotals && !bTotals) {
      return Number(sortDir);
    } else if (!aTotals && bTotals) {
      return -1 * sortDir;
    }

    var aTotal = aTotals[property];
    var bTotal = bTotals[property];

    if (aTotal > bTotal) {
      return Number(sortDir);
    } else if (aTotal < bTotal) {
      return -1 * sortDir;
    }

    return 0;
  };
};

exports.sortByAnalytics = sortByAnalytics;